// context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [ownerToken, setOwnerToken] = useState(
    localStorage.getItem('ownerToken')
  );
  const [customerToken, setCustomerToken] = useState(
    localStorage.getItem('customerToken')
  );

  const ownerLogin = (newToken) => {
    setOwnerToken(newToken);
    localStorage.setItem('ownerToken', newToken);
  };

  const customerLogin = (newToken) => {
    setCustomerToken(newToken);
    localStorage.setItem('customerToken', newToken);
  };

  const ownerLogout = () => {
    setOwnerToken(null);
    localStorage.removeItem('ownerToken');
  };

  const customerLogout = () => {
    setCustomerToken(null);
    localStorage.removeItem('customerToken');
  };

  const logout = () => {
    ownerLogout();
    customerLogout();
  };

  useEffect(() => {
    const storedOwnerToken = localStorage.getItem('ownerToken');
    const storedCustomerToken = localStorage.getItem('customerToken');
    if (storedOwnerToken) {
      setOwnerToken(storedOwnerToken);
    }
    if (storedCustomerToken) {
      setCustomerToken(storedCustomerToken);
    }
  }, []);

  // useEffect(() => {
  //   const handleStorageChange = () => {
  //     const updatedToken = localStorage.getItem('customerToken');
  //     if (updatedToken !== customerToken) {
  //       setCustomerToken(updatedToken);
  //     }
  //   };

  //   window.addEventListener('storage', handleStorageChange);

  //   return () => {
  //     window.removeEventListener('storage', handleStorageChange);
  //   };
  // }, [customerToken]);
  useEffect(() => {
    const handleStorageChange = () => {
      const updatedOwnerToken = localStorage.getItem('ownerToken');
      const updatedCustomerToken = localStorage.getItem('customerToken');

      if (updatedOwnerToken !== ownerToken) {
        setOwnerToken(updatedOwnerToken);
      }
      if (updatedCustomerToken !== customerToken) {
        setCustomerToken(updatedCustomerToken);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [ownerToken, customerToken]);

  return (
    <AuthContext.Provider
      value={{
        ownerToken,
        customerToken,
        ownerLogin,
        customerLogin,
        ownerLogout,
        customerLogout,
        logout,
        isOwnerAuthenticated: !!ownerToken,
        isCustomerAuthenticated: !!customerToken,
        isAuthenticated: !!ownerToken || !!customerToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
